if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        this.autoplayInterval = null;

        // Only set up thumbnail listeners if thumbnails exist.
        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener(
            "slideChanged",
            debounce(this.onSlideChanged.bind(this), 500)
          );

          this.elements.thumbnails
            .querySelectorAll("[data-target]")
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector("button");
              if (button) {
                button.addEventListener(
                  "click",
                  this.onThumbnailClick.bind(this, mediaToSwitch.dataset.target)
                );
              }
            });

          if (
            this.dataset.desktopLayout &&
            this.dataset.desktopLayout.includes("thumbnail") &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }

        if (this.dataset.autoplay === "true") {
          this.startAutoplay();
        }
      }

      startAutoplay() {
        const intervalDuration =
          parseInt(this.dataset.autoplayInterval, 10) || 5000;
        this.stopAutoplay();
        //console.log("Autoplay started with interval:", intervalDuration);
        this.autoplayInterval = setInterval(() => {
          //console.log("Autoplay moving to next slide...");
          this.moveToNextSlide();
        }, intervalDuration);
      }

      stopAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      }

      moveToNextSlide() {
        //console.log("Moving to next slide...");
        const activeMedia = this.elements.viewer.querySelector(".is-active");
        if (!activeMedia) return;

        const nextMedia =
          activeMedia.nextElementSibling ||
          this.elements.viewer.firstElementChild;

        if (nextMedia) {
          //console.log("Next media found:", nextMedia.dataset.mediaId);
          this.setActiveMedia(nextMedia.dataset.mediaId, false);
        }
      }

      onThumbnailClick(mediaId) {
        //console.log("Thumbnail clicked:", mediaId);
        this.stopAutoplay();
        this.setActiveMedia(mediaId, false);
      }

      onSlideChanged(event) {
        const mediaId = event.detail?.currentElement?.dataset?.mediaId;
        //console.log("Slide changed to:", mediaId);

        if (!mediaId) return;

        // Only update thumbnails if they exist.
        const thumbnail = this.elements.thumbnails
          ? this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`)
          : null;
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        //console.log("Switching to media:", mediaId);
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        //console.log(activeMedia);
        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => element.classList.remove("is-active"));

        activeMedia.classList.add("is-active");
        //console.log(prepend);
        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        // **Fix: Prevent scrolling the entire page**

        // setTimeout(() => {
        //   if (!this.mql.matches || this.elements.thumbnails) {
        //     activeMedia.scrollIntoView({
        //       behavior: "smooth",
        //       block: "center",
        //       inline: "center",
        //     });
        //   }
        // }, 50); // Small delay to ensure DOM updates
        setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.offsetHeight; // Force reflow
            this.elements.viewer.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: "smooth",
            });
          }
        }, 50);

        this.playActiveMedia(activeMedia);

        // If thumbnails exist, update the active thumbnail and announce the change.
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail ? activeThumbnail.dataset.mediaPosition : ""
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }
    }
  );
}
